import { Injectable } from '@angular/core';
import { Settings } from 'src/app/modules/firm/pages/settings/settings.component';
import { DatabaseService } from './base/database.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends DatabaseService<any> {
  public settings?: Settings;

  constructor() {
    super('cp_settings');
  }

  async getSettings() {
    const ret = await this.getAll(1, 0);

    this.settings = ret[0];
    return this.settings!;
  }
}
